export default __webpack_public_path__ + "static/education-7c7180092fd2a6f1c92b5cf62768071b.webp";